var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "media-list-item ui-elevation-1 panel",
      class: {
        animate__animated: _vm.deleted || _vm.mediaItem._new,
        animate__zoomInUp: _vm.mediaItem._new,
        animate__zoomOutDown: _vm.deleted,
      },
    },
    [
      _c("div", { staticClass: "media-list-item__image-container" }, [
        !_vm.imageLoaded
          ? _c("div", { staticClass: "media-list-item__image-placeholder" }, [
              _c("i", { staticClass: "fas fa-image" }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.imageLoaded,
              expression: "imageLoaded",
            },
          ],
          attrs: {
            alt: _vm.mediaItem.comment || _vm.mediaItem.title,
            src:
              _vm.recorderApiUrl +
              "/media?secid=" +
              _vm.encodedSecId +
              "&type=image",
            width: "640px",
          },
          on: {
            load: function ($event) {
              _vm.imageLoaded = true
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "media-list-item__play-button",
            on: {
              click: function ($event) {
                return _vm.$emit("playMedia", _vm.mediaItem, _vm.recorderApiUrl)
              },
            },
          },
          [_c("i", { staticClass: "fas fa-play fa-4x fa-inverse" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "media-list-item__image-top-overlay" },
          [
            _c("ui-button", {
              style: { visibility: _vm.mediaItem._selected ? "visible" : "" },
              attrs: {
                icon:
                  (_vm.mediaItem._selected ? "fas" : "fal") +
                  " fa-check-circle",
                tooltip:
                  "" +
                  (_vm.mediaItem._selected ? "Deselect video" : "Select video"),
              },
              on: {
                click: function ($event) {
                  _vm.mediaItem._selected = !_vm.mediaItem._selected
                },
              },
            }),
            _vm._v(" "),
            _c(
              "ui-menu",
              {
                attrs: { icon: "fal fa-ellipsis-v fa-2x", tooltip: "Actions" },
              },
              [
                _c("ui-menu-item", {
                  attrs: { icon: "fal fa-share", label: "Share" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("shareMedia", _vm.mediaItem)
                    },
                  },
                }),
                _vm._v(" "),
                _c("ui-menu-item", {
                  attrs: { icon: "fal fa-download", label: "Download" },
                  on: { click: _vm.downloadMedia },
                }),
                _vm._v(" "),
                _c("ui-menu-item", {
                  attrs: {
                    disabled: _vm.mediaItem.duration === 0,
                    icon: "fal fa-cut",
                    label: "Trim",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit(
                        "trimMedia",
                        _vm.mediaItem,
                        _vm.recorderApiUrl
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("ui-menu-item", {
                  attrs: { icon: "fal fa-trash", label: "Delete" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("confirmDeleteMedia", _vm.mediaItem)
                    },
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "media-list-item__image-bottom-overlay" }, [
          _c("div", { staticClass: "ui-caption" }, [
            _vm._v(_vm._s(_vm._f("bytes")(_vm.mediaItem.size))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ui-caption" }, [
            _vm._v(_vm._s(_vm._f("timecode")(_vm.mediaItem.duration))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("ui-form", { attrs: { "is-processing": _vm.isProcessing } }, [
        _c("div", { staticClass: "media-list-item__footer" }, [
          _c("div", { staticClass: "media-list-item__footer__main" }, [
            _c("div", { staticClass: "media-list-item__footer__main__text" }, [
              !_vm.mediaItem.comment
                ? _c(
                    "div",
                    {
                      staticClass: "ui-subheading",
                      attrs: { title: _vm.mediaItem.title },
                    },
                    [_vm._v(_vm._s(_vm.mediaItem.title))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mediaItem.comment
                ? _c(
                    "div",
                    {
                      staticClass: "ui-subheading",
                      attrs: {
                        title:
                          _vm.mediaItem.comment + " - " + _vm.mediaItem.title,
                      },
                    },
                    [_vm._v(_vm._s(_vm.mediaItem.comment))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "ui-caption" }, [
                _vm._v(_vm._s(_vm._f("date")(_vm.mediaItem.created))),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "media-list-item__footer__main__expand-button" },
              [
                !_vm.expanded
                  ? _c("ui-button", {
                      attrs: { icon: "fal fa-caret-down" },
                      on: {
                        click: function ($event) {
                          _vm.expanded = true
                          _vm.syncMetadata()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.expanded
                  ? _c("ui-button", {
                      attrs: { icon: "fal fa-caret-up" },
                      on: {
                        click: function ($event) {
                          _vm.expanded = false
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.expanded
            ? _c(
                "div",
                { staticClass: "media-list-item__footer__expanded" },
                [
                  _c("ui-input", {
                    attrs: { label: "Title" },
                    model: {
                      value: _vm.comment,
                      callback: function ($$v) {
                        _vm.comment = $$v
                      },
                      expression: "comment",
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-text-area", {
                    attrs: { autogrow: "", label: "Description" },
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-chips", {
                    attrs: { placeholder: "Add tag" },
                    model: {
                      value: _vm.tags,
                      callback: function ($$v) {
                        _vm.tags = $$v
                      },
                      expression: "tags",
                    },
                  }),
                  _vm._v(" "),
                  _c("ui-chips", {
                    attrs: { placeholder: "Add participant" },
                    model: {
                      value: _vm.participants,
                      callback: function ($$v) {
                        _vm.participants = $$v
                      },
                      expression: "participants",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "media-list-item__footer__expanded__actions",
                    },
                    [
                      _c("ui-button", {
                        attrs: {
                          primary: "",
                          text: "Save",
                          tooltip: "Save changes to metadata",
                        },
                        on: { click: _vm.updateMedia },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }